import { DataObject } from '@/utils/DataObject';
import { MediaTransformer } from '../media/MediaTransformer';
import { Artist } from './Artist';
import { Artwork } from '../artwork/Artwork';
import { ArtworkTransformer } from '../artwork/ArtworkTransformer';


export class ArtistTransformer {

  private parseArtworks(data: DataObject = {}) {

    if (data.artworks) {
      return data.artworks.map((artwork: Artwork) => {
        artwork.artist = new Artist({
          id: data.id,
          name: data.name,
          slug: data.slug
        });
        return new ArtworkTransformer().toClass(artwork)
      });
    }

    return [];
  }

  public toClass(data: DataObject = {}): Artist {
    return new Artist({
      id: data.id,
      name: data.name,
      slug: data.slug,
      about: data.about,
      absenceUntil: data.absent_until,
      hasCV: data.has_cv,
      media: new MediaTransformer().toClass(data.media),
      artworks: this.parseArtworks(data),
      video: data.video,
      posts: data.posts,
      isVisible: data.is_visible,
      status: data.status,
      my_subscription_id: data.my_subscription_id,
      is_merchandise: data.is_merchandise
    })
  }

}
